import { warn } from '@execonline-inc/logging';
import { InvalidUrlError } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { AppyError, deleteToApi } from '../../../../../../../../../Appy';
import { handleError } from '../../../../../../../../../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../../../../../../../../../LinkyLinky';
import ReactionComponent, { RCProps } from '../../../../../../../../../ReactionComponent';
import { Link } from '../../../../../../../../../Resource/Types';
import GroupParticipantsStore from '../../../../../../GroupParticipantsStore/Store';
import RemoveParticipantStore from './Store';
import { State } from './Types';

interface Props extends RCProps<RemoveParticipantStore> {
  groupParticipantsStore: GroupParticipantsStore;
}

type RemoveParticipantError = AppyError | InvalidUrlError | MissingLinkError;

const handleRemoveParticipantError =
  (store: RemoveParticipantStore) => (error: RemoveParticipantError) => {
    switch (error.kind) {
      case 'missing-link-error':
        break;
      case 'invalid-url-error':
        store.error('We are unable to process your request at this time');
        warn('ParticipantsReactions', error.kind, error);
        break;
      default:
        handleError(store, error);
    }
  };

class RemoveParticipantReactions extends ReactionComponent<RemoveParticipantStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'ready':
        break;
      case 'deleting':
        Task.succeed<RemoveParticipantError, ReadonlyArray<Link>>(state.participant.links)
          .andThen(findLinkT('delete'))
          .andThen(deleteToApi)
          .fork(handleRemoveParticipantError(store), store.success);
        break;
      case 'waiting':
        break;
      case 'deleted':
        this.props.groupParticipantsStore.filterRemovedParticipant(state.participant);
        break;
      case 'failure':
        break;
      case 'success':
        break;
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default RemoveParticipantReactions;
